import React from 'react';
import { Table } from 'semantic-ui-react'

export const Scorecard = (props) => {
  return (
    <div style={{overflowY: 'auto'}}>
      <Table definition collapsing >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell/>
              <Table.HeaderCell>Cumulative Correct Entries/Total Entries</Table.HeaderCell>
              <Table.HeaderCell>Cumulative Total Errors</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <Table.Row>
              <Table.Cell>Item Identifier Accuracy Rate (Cumulative)</Table.Cell>
              <Table.Cell>{props.correctEntries[0]}/{props.totalEntries[0]}</Table.Cell>
              <Table.Cell>{props.totalErrorEntries[0]}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Wholesale Price Accuracy Rate (Cumulative)</Table.Cell>
              <Table.Cell>{props.correctEntries[1]}/{props.totalEntries[1]}</Table.Cell>
              <Table.Cell>{props.totalErrorEntries[1]}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Items per ASIN Accuracy Rate (Cumulative)</Table.Cell>
              <Table.Cell>{props.correctEntries[2]}/{props.totalEntries[2]}</Table.Cell>
              <Table.Cell>{props.totalErrorEntries[2]}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Total</Table.Cell>
              <Table.Cell>{(props.correctEntries[0] + props.correctEntries[1] + props.correctEntries[2])}/{(props.totalEntries[0] + props.totalEntries[1] + props.totalEntries[2])}</Table.Cell>
              <Table.Cell>{(props.totalErrorEntries[0] + props.totalErrorEntries[1] + props.totalErrorEntries[2])}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell style={{background: 'white'}}></Table.Cell>
              <Table.Cell style={{borderLeft: 'none'}}></Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Total Errors / Errors Allowed</Table.Cell>
              <Table.Cell>{(props.totalErrorEntries[0] + props.totalErrorEntries[1] + props.totalErrorEntries[2])}/{props.totalErrorsAllowed}</Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/scorecard.js